import { Flex, Popover, Typography } from "antd";
import { SelectedConversaton } from "../../../store/slices/conversation.slice";
import { HeadingText } from "../../generic/Typography";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import {
  getConversationParticipantSummary,
  participantLabel,
} from "../../../utils/conversationDisplay";
const boxStyle: React.CSSProperties = {
  borderBottom: "1px solid rgb(223, 226, 232)",
  height: "70px",
  padding: "13px",
  background: "white",
};
const ParticipantDetails = ({ labels }: { labels: string[] }) => (
  <Flex vertical gap={4} style={{ minWidth: "220px" }}>
    {labels.map((label) => (
      <Typography.Text key={label} style={{ fontSize: "12px" }}>
        {label}
      </Typography.Text>
    ))}
  </Flex>
);

const ChatHeaderConversation = ({
  selectedConversation,
}: {
  selectedConversation: SelectedConversaton;
}) => {
  const { data: contacts } = useSelector((state: RootState) => state.contacts);
  const participantSummary = getConversationParticipantSummary(
    selectedConversation.participants,
    contacts
  );
  const participantLabels = selectedConversation.participants.map((participant) =>
    participantLabel(participant, contacts)
  );

  return (
    <Flex align="center" style={boxStyle}>
      <Flex gap={8} style={{ minWidth: 0 }}>
        <Popover
          content={<ParticipantDetails labels={participantLabels} />}
          trigger="hover"
        >
          <span style={{ flex: "1 1 0", minWidth: 0 }}>
            <HeadingText
              text={participantSummary.names || "Conversation"}
              style={{ display: "block" }}
            />
          </span>
        </Popover>
        {participantSummary.additionalParticipantCount > 0 && (
          <Popover
            content={<ParticipantDetails labels={participantLabels.slice(2)} />}
            trigger="hover"
          >
            <span
              style={{
                cursor: "help",
                flex: "0 0 auto",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              +{participantSummary.additionalParticipantCount}
            </span>
          </Popover>
        )}
      </Flex>
    </Flex>
  );
};

export default ChatHeaderConversation;
